<template>
  <div class="close-input">
    <el-input v-model="closeReason" type="textarea" :rows="2" placeholder="请输入关闭原因"/>
  </div>
</template>

<script>
export default{
  name: "CloseInput",
  data(){
    return { closeReason: '' }
  },
  watch: {
    closeReason(val){
      this.$emit('change', val)
    }
  },
  created(){}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/AntWithHold/CloseInput.vue